var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_841_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4399 11.8059L11.7271 39.5723C11.4098 39.8792 11.2274 40.2995 11.22 40.7408C11.2126 41.1822 11.3809 41.6083 11.6877 41.9256L31.3556 62.2639C31.9692 62.8984 32.8099 63.2633 33.6925 63.278C34.5752 63.2928 35.4276 62.9564 36.0622 62.3427L62.3822 36.8902C63.0168 36.2765 63.3816 35.4359 63.3964 34.5532C63.4112 33.6705 63.0747 32.8182 62.4611 32.1836L42.7932 11.8454C42.4864 11.5281 42.066 11.3457 41.6247 11.3383C41.1834 11.3309 40.7572 11.4991 40.4399 11.8059ZM38.3976 38.4229L17.1171 38.9903L39.6776 17.1734L38.3976 38.4229ZM33.2727 41.8886L32.2747 58.4261L16.711 42.332L33.2727 41.8886ZM36.6124 41.7989L40.0049 41.716C40.4216 41.7052 40.819 41.5384 41.1186 41.2487C41.4182 40.9589 41.5982 40.5673 41.623 40.1512L41.8195 36.7634L58.1796 36.3239L35.6281 58.1322L36.6124 41.7989ZM42.033 33.417L43.0296 16.878L58.5961 32.9751L42.033 33.417Z",
    fill: "#BEBCB8",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_841_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.2566,
    height: 53.2566,
    fill: "white",
    transform: "translate(0 37.0219) rotate(-44.0401)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.641fe444781babaaa226a9985114d58c.svg";
export { ForwardRef as ReactComponent };